import { useMemo } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

function useHistroy() {
  const apiInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });
  const { pageId } = useParams();
  return {
    getIncidents: () => apiInstance.post("/incident-history/" + `${pageId}`),
  };
}

export default useHistroy;
